import { abrirGovbr } from './actions';
import { estaLogado } from './helper';
import configFirebase, { getConfig } from 'ext-libs/firebase';
import { getUrlVars } from '../shared/helper/utilitarioUrl';
import { WorkInProgress } from 'shared/template/InfoScreen';
import history from '../history';
import LoginImpl from "./LoginImpl";
import React from 'react';
import LoadingCircular from 'shared/template/LoadingCircular';

const URL_CRIAR_CONTA = 'https://acesso.gov.br/acesso/#/primeiro-acesso?clientDetails=eyJjbGllbnRVcmkiOiJodHRwczpcL1wvbWV1Lmluc3MuZ292LmJyXC8iLCJjbGllbnROYW1lIjoiTWV1IElOU1MiLCJjbGllbnRWZXJpZmllZFVzZXIiOmZhbHNlfQ%3D%3D';
const URL_ESQUECI_SENHA = 'https://acesso.gov.br/acesso/#/recuperarSenha?clientDetails=eyJjbGllbnRVcmkiOiJodHRwczpcL1wvbWV1Lmluc3MuZ292LmJyXC8iLCJjbGllbnROYW1lIjoiTWV1IElOU1MiLCJjbGllbnRWZXJpZmllZFVzZXIiOmZhbHNlfQ%3D%3D';
const URL_INSCREVER_INSS = 'https://cnisnet.inss.gov.br/cnisinternet/faces/pages/perfil.xhtml;jsessionid=mwD7dRHMx7GLdxxB7x67fdNtttk4r9X0rtstktSdd1vLMhpbz41L!1762142665';

class Login extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      manutencao: false,
      mensagemSistemaIndisponivel: "",
      loading: true,
    };
  }

  setManutencao = (value) => {
    this.setState((prevState) => ({
      ...prevState,
      manutencao: value
    }))
  }

  getManutencao = () => {
    return this.state.manutencao;
  }

  setMensagemSistemaIndisponivel = (value) => {
    this.setState((prevState) => ({
      ...prevState,
      mensagemSistemaIndisponivel: value
    }))
  }

  getMensagemSistemaIndisponivel = () => {
    return this.state.mensagemSistemaIndisponivel;
  }

  checkUrl = () => {
    try {
      const mensagemSistemaIndisponivel = getConfig("mensagemSistemaIndisponivel");      
      this.setMensagemSistemaIndisponivel(mensagemSistemaIndisponivel);

      const sistemaIndisponivel = getConfig("sistemaIndisponivel");
      this.setManutencao(sistemaIndisponivel == "true")

    } catch (e) {
      this.setManutencao(false);
    } finally {
      this.setState({ loading: false });
    }
  };

  componentWillMount() {
    let page = getUrlVars()['page'];
    if (estaLogado()) {
      history.replace(page ? page : '/');
    } else if (localStorage.getItem('auth') === 'govbr' && page) { // Helô
      abrirGovbr();
    }

    configFirebase().then(this.checkUrl)
  }

  render() {

    if (this.state.loading) {
      return (
        <div className='govbr'>
          <LoadingCircular />
        </div>
      )
    }

    let inscreverCnisObj = { "externalLink": "Inscrever no INSS", "url": URL_INSCREVER_INSS };

    if (this.getManutencao()) {
      return (
        <div className='govbr'>
          <WorkInProgress
            primaryText="Sistema não disponível."
            secondaryText={this.getMensagemSistemaIndisponivel()}
          />
        </div>
      )
    } else {
      return (
        <div className='govbr'>
          <LoginImpl
            criarContaUrl={URL_CRIAR_CONTA}
            esqueciSenhaUrl={URL_ESQUECI_SENHA}
            inscriverInssUrl={URL_INSCREVER_INSS}
            increverCnisObj={inscreverCnisObj}
            abrirGovbr={abrirGovbr}
          />
        </div>
      )
    }
  }
}

export default Login;